import {Repository} from '@/repositories/Base/Repository'

class OrderRepository extends Repository {
    endpoint = 'mapping/exams/order/table'
    endpointCopy = 'mapping/exams/order/copy'
    postCopy(params) {
        return this.$axios.post(`${this.endpointCopy}`, params)
    }
}

export default new OrderRepository()
